/* eslint-disable no-param-reassign, max-lines, max-params */
import { api } from "jiffy-api";
import debounce from "lodash.debounce";

const initialState = {
  presetQueue: {},
  side: null,
  currentRequest: null
};

const debouncedSavePreset = debounce(async (side, presetQueue, callback) => {
  await api.printOnDemand.updateMadePreset({ side }, { made_preset: presetQueue });
  callback?.();
}, 500);

const presetModule = {
  namespaced: true,

  state() {
    return { ...initialState };
  },

  mutations: {
    setSide(state, side) {
      state.side = side;
    }
  },

  actions: {
    async createPreset({ state }, presetData) {
      await api.printOnDemand.createMadePreset({ side: state.side }, { made_preset: presetData });
    },
    addToPresetQueue({ state, dispatch }, presetData) {
      state.presetQueue = {
        ...state.presetQueue,
        ...presetData
      };
      dispatch("savePresetQueue");
    },
    clearPresetQueue({ state }) {
      state.presetQueue = {};
      state.currentRequest?.cancel();
      state.currentRequest = null;
    },
    async savePresetQueue({ state, dispatch }) {
      const currentPresetQueue = { ...state.presetQueue };
      state.currentRequest = debouncedSavePreset(state.side, currentPresetQueue, () => {
        state.currentRequest = null;
        if (Object.keys(state.presetQueue).length > 0) {
          dispatch("savePresetQueue");
        }
        state.presetQueue = {};
      });
    }
  }
};

export default presetModule;
